// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <detail-view
  :endpoint="endpoint + 'endpoints'"
  :hiddenValues="hiddenValues"
  name="Endpoint"
  parentRoute="endpoints"
  permissions="endpoints"
  :values="values"
  v-model="data"
  ></detail-view>
</template>
<script>
import { mapGetters } from 'vuex'
import DetailView from '@sdgsystems/vue-common/components/DetailView.vue'
import {ENDPOINT} from '@/shared/constants'

export default {
  components: {
    DetailView
  },

  created: function () {
    if (this.$route.params.id === 'new') {
      this.data.xycoordinates = []
    }
  },

  watch: {
    data: function () {
      if (this.data.xycoordinates === null) {
        this.data.xycoordinates = []
      }
    }
  },

  data () {
    return {
      data: {},
      endpoint: ENDPOINT,
      values: [
        {
          name: 'Basic',
          items: [
            [
              {
                name: 'Name',
                value: 'name'
              },
              {
                name: 'Map',
                value: 'map',
                context: ENDPOINT + 'maps',
                type: 'select',
                itemText: 'name',
                itemValue: '_id',
                multiple: false
              },
              {
                name: 'UUID',
                value: 'uuid'
              },
              {
                name: 'External Gate',
                value: 'externalgate',
                type: 'checkbox'
              },
              {
                name: 'Coordinate (X)',
                value: 'xycoordinates.0',
                required: false,
                valueType: 'number',
                width: 'xs6 md2'
              },
              {
                name: 'Coordinate (Y)',
                value: 'xycoordinates.1',
                required: false,
                valueType: 'number',
                width: 'xs6 md2'
              },
              {
                name: 'ID',
                value: '_id',
                disabled: true
              },
              {
                name: 'Key',
                value: 'key',
                disabled: true
              },
              {
                name: 'AutoEnroll',
                value: 'autoEnroll.enabled',
                type: 'checkbox'
              },
              {
                name: 'AutoEnroll Locations',
                value: 'autoEnroll.locationEnabled',
                type: 'checkbox'
              },
              {
                name: 'Description',
                value: 'description',
                width: 'xs12'
              }
            ]
          ]
        },
        {
          name: 'Antennas',
          items: [
            [
              {
                text: 'Antennas',
                value: 'antennas',
                type: 'component',
                component: 'endpoint-antennas'
              }
            ]
          ]
        },
        {
          name: 'Status',
          items: [
            [
              {
                text: 'Status',
                value: 'status',
                type: 'component',
                component: 'endpoint-status'
              }
            ]
          ]
        },
        {
          name: 'QR Code',
          items: [
            [
              {
                text: 'QR Code',
                value: 'qrcode',
                type: 'component',
                component: 'endpoint-qrcode'
              }
            ]
          ]
        }
        // {
        //   name: 'FB Status',
        //   items: [
        //     [
        //       {
        //         text: 'FB Status',
        //         value: 'status',
        //         type: 'component',
        //         component: 'endpoint-status-fb'
        //       }
        //     ]
        //   ]
        // },
        // {
        //   name: 'Config',
        //   items: [
        //     [
        //       {
        //         text: 'Config',
        //         value: 'status',
        //         type: 'component',
        //         component: 'endpoint-config'
        //       }
        //     ]
        //   ]
        // }
      ]
    }
  },

  computed: {
    ...mapGetters([
      'selectedSite'
    ]),

    hiddenValues: function () {
      return [{
        path: 'site',
        value: this.selectedSite._id
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EndpointEdit.vue